<template>
  <div class="flex items-center justify-center min-h-screen">
    <div class="bg-[#1a1820] p-8 rounded-2xl shadow-xl w-full max-w-md mx-auto">
      <h1 class="text-3xl font-bold text-center mb-6 text-white">Admin Panel</h1>

      <!-- Message Box -->
      <div v-if="message" :class="messageClass" class="mb-4 p-3 rounded-md text-center text-sm">
        {{ message }}
      </div>

      <!-- Login Form -->
      <div v-if="!isLoggedIn && !showRegister">
        <h2 class="text-2xl font-semibold mb-6 text-center text-white">Login</h2>
        <form @submit.prevent="login" class="space-y-4">
          <div>
            <label for="login-username" class="block text-sm font-medium mb-1 text-gray-400">Username</label>
            <input type="text" id="login-username" v-model="loginForm.username" required class="w-full p-3 bg-[#24222c] rounded-lg border border-[#3e3c49] text-purple-300 focus:outline-none focus:ring-2 focus:ring-purple-500">
          </div>
          <div>
            <label for="login-password" class="block text-sm font-medium mb-1 text-gray-400">Password</label>
            <input type="password" id="login-password" v-model="loginForm.password" required class="w-full p-3 bg-[#24222c] rounded-lg border border-[#3e3c49] text-purple-300 focus:outline-none focus:ring-2 focus:ring-purple-500">
          </div>
          <button type="submit" class="w-full p-3 bg-purple-600 hover:bg-purple-700 text-white font-semibold rounded-lg shadow-md transition-colors duration-200">
            Login
          </button>
        </form>
        <div class="mt-4 text-center text-sm">
          <p class="text-gray-400">Don't have an account? <span @click="toggleForm" class="text-purple-400 hover:text-purple-300 cursor-pointer">Register here.</span></p>
        </div>
      </div>

      <!-- Registration Form -->
      <div v-if="!isLoggedIn && showRegister">
        <h2 class="text-2xl font-semibold mb-6 text-center text-white">Register</h2>
        <form @submit.prevent="register" class="space-y-4">
          <div>
            <label for="register-username" class="block text-sm font-medium mb-1 text-gray-400">Username</label>
            <input type="text" id="register-username" v-model="registerForm.username" required class="w-full p-3 bg-[#24222c] rounded-lg border border-[#3e3c49] text-purple-300 focus:outline-none focus:ring-2 focus:ring-purple-500">
          </div>
          <div>
            <label for="register-password" class="block text-sm font-medium mb-1 text-gray-400">Password</label>
            <input type="password" id="register-password" v-model="registerForm.password" required class="w-full p-3 bg-[#24222c] rounded-lg border border-[#3e3c49] text-purple-300 focus:outline-none focus:ring-2 focus:ring-purple-500">
          </div>
          <button type="submit" class="w-full p-3 bg-purple-600 hover:bg-purple-700 text-white font-semibold rounded-lg shadow-md transition-colors duration-200">
            Register
          </button>
        </form>
        <div class="mt-4 text-center text-sm">
          <p class="text-gray-400">Already have an account? <span @click="toggleForm" class="text-purple-400 hover:text-purple-300 cursor-pointer">Login here.</span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router';

const API_URL = '/api';

export default {
  name: 'AdminPanel',
  setup() {
    const router = useRouter();
    return { router };
  },
  data() {
    return {
      isLoggedIn: false,
      showRegister: false,
      message: '',
      messageType: '',
      loginForm: {
        username: '',
        password: '',
      },
      registerForm: {
        username: '',
        password: '',
      },
    };
  },
  computed: {
    messageClass() {
      return this.messageType === 'success' ? 'bg-green-600 text-white' : 'bg-red-600 text-white';
    },
  },
  methods: {
    showMessage(message, type = 'success') {
      this.message = message;
      this.messageType = type;
    },
    checkAuth() {
      const token = localStorage.getItem('token');
      this.isLoggedIn = !!token;
      if (this.isLoggedIn) {
        this.router.push('/admindashboard');
      }
    },
    async login() {
      try {
        const response = await fetch(`${API_URL}/login`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(this.loginForm),
        });

        const data = await response.json();
        if (response.ok) {
          localStorage.setItem('token', data.token);
          this.showMessage('Login successful!', 'success');
          this.router.push('/AdminDashboard');
        } else {
          this.showMessage(data.message || 'Login failed.', 'error');
        }
      } catch (error) {
        this.showMessage('An error occurred during login.', 'error');
      }
    },
    async register() {
      try {
        const response = await fetch(`${API_URL}/register`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(this.registerForm),
        });

        const data = await response.json();
        if (response.ok) {
          this.showMessage('Registration successful. You can now log in.', 'success');
          this.registerForm.username = '';
          this.registerForm.password = '';
          this.showRegister = false;
        } else {
          this.showMessage(data.message || 'Registration failed.', 'error');
        }
      } catch (error) {
        this.showMessage('An error occurred during registration.', 'error');
      }
    },
    toggleForm() {
      this.showRegister = !this.showRegister;
      this.message = '';
    },
  },
  mounted() {
    this.checkAuth();
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
</style>
